import { blockedStatus, enStatus, ICourse } from 'interface/course';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { clickCourseOffer, viewCourseOffer } from 'actionCreators/judasLog';
import { hjTagging, openUpsell } from 'utils';
import courseService from 'services/course';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';
import { IUser } from 'interface/user';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  container: {
    '& h3': {
      '@media (max-width: 1024px)': {
        fontSize: 16,
      },
      '@media (max-width: 425px)': {
        textAlign: 'justify',
      },
      color: theme.variables.courseTheme.text,
    },
    '& button': {
      textTransform: 'capitalize',
      color: theme.palette.common.white,
      minWidth: 'fit-content',
      fontWeight: 600,
      fontSize: 16,
      '@media (max-width: 1024px)': {
        fontSize: 14,
      },
    },
    rowGap: theme.spacing(4),
    margin: theme.spacing(4, 0),
    display: 'flex',
    flexWrap: 'wrap',
    borderRadius: 8,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(6),
    background: theme.variables.courseTheme.cardBackground,
  },
}));

const NotPurchased = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const course = useAppSelector((state) => state.course as ICourse);
  const user = useAppSelector((state) => state.user as IUser);

  const purchase = (event: SyntheticEvent) => {
    const offer = {
      id: 0,
      producer_id: course.producer.id,
      type: 0,
      show_type: 1,
      content: `${course.offer}`,
      description: course.description,
      title: course.title,
    };

    if (!user.email && course.is_free) {
      return history.push(`/cadastro/${course.hash}`);
    }

    if (course.is_free && !!user.email) {
      return registerFreeCourse();
    }

    openUpsell(event, offer, 'CURSO', user);
    clickCourseOffer(course);
  };

  const registerFreeCourse = async () => {
    setLoading(true);
    await courseService.register(course.hash);
    setLoading(false);
    window.location.reload();
  };

  useEffect(() => {
    viewCourseOffer(course);
    hjTagging('EXIBIU-OFERTA');
  }, [course]);

  const isBlocked = [...blockedStatus, enStatus.SOMETHING_FREE].includes(course.status);
  const showOffer = Boolean(course.offer) || course.access_type === 2;

  if (!isBlocked || !showOffer) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Typography variant='h3'>
        Parece que você não tem acesso a esse curso. Adquira ele agora{course.is_free ? ' gratuitamente!' : '!'}
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={purchase}
        disabled={loading}
        startIcon={loading && <CircularProgress size={14} color='inherit' />}
      >
        Adquirir curso
      </Button>
    </div>
  );
};

export default NotPurchased;
